module.exports = __webpack_public_path__ + "static/Grand Canyon-62cde4e83222004009b749274a702129.jpg";